import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import { useNewScreenQuery } from '@intigral/domain/lib/presentation/hooks/useNewScreenQuery';
import { useWindowVirtualizer } from '@tanstack/react-virtual';
import { Suspense, useEffect, useState } from 'react';
import { ComponentMapper } from '../managers/componentMapper';
import { handleDataLoaderType } from '../managers/dataLoaderHandler';
import { getUserInfo } from '../utils/user';
import { RenderedComponent } from './ScreenCarousel';
import Loader from '../components/Loader';
import { COMPONENT_TYPES } from '@libs/constants';

type SearchScreenProps = {
    screenKey: string;
    screenName: string;
};

const SearchScreen: React.FC<SearchScreenProps> = ({ screenKey, screenName }) => {
    const userInfo = getUserInfo();

    const { isLoading, isError, data, error } = useNewScreenQuery(
        screenName,
        screenKey,
        'deviceType=pc',
        userInfo.apiKey
    );
    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const components = data?.data?.content?.carousels ?? [];

    const windowVirtualizer = useWindowVirtualizer({
        count: components.length,
        estimateSize: () => 550,
        overscan: 5, // Adjust based on your needs
        scrollMargin: 200,
    });

    // if (isLoading) {
    //     return 'LOADING SCREEN';
    // }

    if (isError) {
        return 'ERROR';
    }

    return (
        <div>
            {windowVirtualizer.getVirtualItems().map((virtualItem) => (
                <RenderedComponent
                    carousel={components[virtualItem.index]}
                    dataLoader={async (carousel) => {
                        const result = await handleDataLoaderType(carousel as Carousel, null, '', null);
                        return result;
                    }}
                    render={(carousel, data) => {
                        return (
                            <Suspense fallback={<Loader componentName={COMPONENT_TYPES.SEARCH_RESULTS} />}>
                                <ComponentMapper carousel={carousel} data={data} />
                            </Suspense>
                        );
                    }}
                    key={virtualItem.index}
                />
            ))}
        </div>
    );
};

export default SearchScreen;
